import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface RefreshTokenResponse {
  token: string;
}

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private myToken: string | null = null;
  private myTokenCache!: Observable<RefreshTokenResponse>;

  constructor() {
    this.token = localStorage.getItem('token'); // sync on init
  }

  // Allow null
  get token(): string | null {
    return this.myToken;
  }

  set token(token: string | null) {
    this.myToken = token;
  }

  public createTokenHeader(): HttpHeaders {
    const token = localStorage.getItem('token');
    let headers = new HttpHeaders().set('Content-Type', 'application/json');

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
  }

  get tokenStream(): Observable<string> {
    return this.myTokenCache.pipe(map((response) => response.token));
  }

  public setToken(token: string) {
    this.token = token;
    localStorage.setItem('token', token);
  }

  public clearToken() {
    this.token = null;
    localStorage.removeItem('token');
  }
}